import { isPayPerUseSelector } from "./CommonBenefitSelectors";

export * from "./ChatbotSelectors";
export * from "./CommonBenefitSelectors";
export * from "./DestinationSelectors";
export * from "./EpcsSelectors";
export * from "./GeneralInfoSelectors";
export * from "./IncidentReportFormSelectors";
export * from "./LicensePlateVinLookupSelectors";
export * from "./PartnerDetailsSelectors";
export * from "./ServiceDetailsSelectors";
export * from "./ServiceInfoSelectors";
export * from "./ServiceRequestPayloadSelectors";
export * from "./SubmitRequestSelectors";
export * from "./UrlShortenerSelectors";
export * from "./ExperienceSelector";
export * from "./BenefitSelectors";
export * from "../features/FeatureFlags/selectors";

export const getAccessToken = (state) => state.accessToken;
export const getVinSaga = (state) => state.vinCapture;
export const getCurrentLocation = (state) => state.currentLocation;
export const getServiceTime = (state) => state.serviceTime;
export const getPepSession = (state) => state.pepSession;
export const getGoogleDestinationsResult = (state) =>
  state.googleDestinationsResult;
export const getGoogleDetailsResult = (state) => state.googleDetailsResult;
export const getRequestInfo = (state) => state.submitRequest;
export const getPlaces = (state) => state.nearByDestinations.places;
export const getMakeModel = (state) => state.makeModel;
export const getDriverList = (state) => state.driverList;
export const getUserDetails = (state) => state.userDetails;
export const hasPepSessionSelector = (state) =>
  isPayPerUseSelector(state) &&
  state.partnerDetails.partnerDetails.partnerCode === "PEP";
export const getServiceTransition = (state) => state?.serviceTransition || {};
